// Constants shared by every pill-related helper.
//
// - `PILL_CLASS`        marker class used to detect pill nodes during
//                       DOM walks (serialiser, isPillElement, …).
// - `INTER_PILL_SPACER` zero-width text inserted between two adjacent
//                       pill siblings so the caret has a real text
//                       node to land on (browsers collapse the caret
//                       across runs of `contenteditable="false"`).
//                       Stripped on serialise — never leaks to storage.

export const PILL_CLASS        = 'chip'
export const INTER_PILL_SPACER = '​'
